import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { PageHero, SectionTitle } from "../components/blocks";
import { Reveal } from "../components/motion/Reveal";
import { IMAGES } from "../content/defaultContent";

export default function Export() {
  const { content } = useLanguage();
  const e = content.exportPage;
  return (
    <div data-testid="export-page">
      <PageHero overline={e.hero.overline} title={e.hero.title} subtitle={e.hero.subtitle} image={IMAGES.export} />

      <section className="bg-brand-beige py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal variant="up" className="mb-20 max-w-3xl text-xl font-light leading-relaxed text-brand-black/80 md:text-2xl">
            {e.body}
          </Reveal>

          <div className="grid grid-cols-1 gap-px overflow-hidden border border-brand-grey bg-brand-grey md:grid-cols-2">
            {e.capabilities.map((cap, i) => (
              <Reveal key={i} variant="up" delay={i * 0.08} className="bg-white p-10">
                <span className="font-mono text-sm text-brand-gold">0{i + 1}</span>
                <h3 className="mt-5 font-serif text-2xl text-brand-green">{cap.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-brand-black/70">{cap.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-brand-green py-24 text-white md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <SectionTitle light className="mb-14">Régions desservies</SectionTitle>
          <div className="flex flex-wrap gap-4">
            {e.regions.map((r, i) => (
              <Reveal
                key={i}
                variant="zoom"
                delay={i * 0.08}
                className="rounded-none border border-brand-gold/40 px-8 py-4 text-sm uppercase tracking-[0.12em] text-brand-gold"
              >
                {r}
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
